import variables from 'styles/variables.scss';
import React, { memo, useEffect } from 'react';
import Slider from 'rc-slider';
import range from 'lodash/range';
import { spliceLabelOnMobile } from 'utils/helpers';
import 'rc-slider/assets/index.css';
import { areEqualFields } from 'utils/form';
import styles from './Slider.module.scss';

const { yellowColor, primaryColor, whiteSmokeColor } = variables;

const generateMarks = (min, max, step = 1, units = '') =>
  range(min, max + step, step).reduce((acc, v) => ({ ...acc, [v]: `${v}${units || ''}` }), {});

const sliderStyleProps = {
  railStyle: {
    backgroundColor: whiteSmokeColor,
    height: '8px',
    marginBottom: '16px',
  },
  trackStyle: {
    backgroundColor: primaryColor,
    height: '8px',
  },
  handleStyle: {
    backgroundColor: yellowColor,
    border: '3px solid #FFF',
    borderRadius: '50%',
    width: '28px',
    height: '28px',
    boxSizing: 'border-box',
    boxShadow: 'none',
    marginTop: '-10px',
  },
  dotStyle: {
    display: 'none',
  },
};

const SliderInput = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue, setFieldTouched }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  const { label, style, min, max, note, step = 1, units = '' } = props;
  const { value, name } = field;

  const handleChange = React.useCallback(
    (v) => {
      setFieldValue(name, v);
      setFieldTouched(name, true);
    },
    [setFieldValue, name, setFieldTouched],
  );

  useEffect(() => {
    if (!Number.isFinite(value)) {
      setFieldValue(name, min);
    }
    if (Number.isFinite(value) && value < min) setFieldValue(name, min);
  }, [name, value, setFieldValue, min]);

  return (
    <div className="field-wrapper" style={style}>
      <div className={styles.sliderContainer} name={name}>
        <Slider
          {...sliderStyleProps}
          className={styles.slider}
          name={name}
          value={value}
          step={step}
          onChange={handleChange}
          dots={false}
          id={name}
          min={min}
          max={max}
          marks={generateMarks(min, max, step, units)}
        />
      </div>
      <label htmlFor={name} className="label-when-focused-input number-label" id={`label-${name}`}>
        {spliceLabelOnMobile(label)}
      </label>
      {note ? <small className="muted">{note}</small> : null}
      {touched[name] && errors[name] && <div className="error-text">{errors[name]}</div>}
    </div>
  );
};

export default memo(SliderInput, areEqualFields);
